import { collect } from '@/analytics';
import { collectTrackData } from '@/utils/Tracker/tracker';
import { OPTIONS } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.types';
import { routesV2 } from '@/routes/routes';
import { locale } from '@/utils/locale';

const EVENTS = {
  NAME: 'gaEvent',
  CATEGORY: 'Gator',
  ACTIONS: {
    GATOR_SHORTCUT: 'Atalhos Gator',
  },
  LABELS: {
    [OPTIONS.CREATE_SITE]: 'Criar site',
    [OPTIONS.CREATE_EMAIL]: 'Criar e-mail',
    [OPTIONS.MARKETING_TIPS]: 'Marketing',
    [OPTIONS.SUPPORT]: 'Suporte',
    [OPTIONS.DOMAIN_PURCHASE]: 'Contratar domínio',
    [OPTIONS.CONFIGURE_DOMAIN]: 'Configurar domínio',
    [OPTIONS.CHECK_ACCOUNT]: 'Checar minha conta',
    [OPTIONS.CREATE_POSTS]: 'Criar posts',
    [OPTIONS.CONTRACT_PRODUCT]: 'Contratar produto',
  },
};

const HOME_EVENTS = {
  NAME: 'gaEvent',
  CATEGORY: 'Home-Portal',
  ACTION: 'Gator IA',
  LABELS: {
    TYPED: 'mensagem digitada',
    VOICE: 'Voz',
    [OPTIONS.CREATE_SITE]: 'Criar site',
    [OPTIONS.CREATE_EMAIL]: 'Criar e-mail',
    [OPTIONS.MARKETING_TIPS]: 'Marketing',
    [OPTIONS.SUPPORT]: 'Suporte',
    [OPTIONS.DOMAIN_PURCHASE]: 'Contratar domínio',
    [OPTIONS.CONFIGURE_DOMAIN]: 'Configurar dominio (DNS)',
    [OPTIONS.CHECK_ACCOUNT]: 'Checar minha conta',
    [OPTIONS.CREATE_POSTS]: 'Criar post',
    [OPTIONS.CONTRACT_PRODUCT]: 'Contratar produto',
  },
};

const MODAL_EVENTS = {
  NAME: 'gaEvent',
  CATEGORY: 'Gator',
  ACTION: 'Modal Apresentação Gator 2.0',
  LABELS: {
    OPEN: 'Abertura',
    CTA: 'Quero testar o Novo Gator',
    CLOSE: 'Fechamento',
  },
};

const emitModalEvent = (label: string) => {
  collect({
    event: MODAL_EVENTS.NAME,
    gaEventCategory: MODAL_EVENTS.CATEGORY,
    gaEventAction: MODAL_EVENTS.ACTION,
    gaEventLabel: label,
  });

  collectTrackData({
    campaign: MODAL_EVENTS.CATEGORY,
    action: MODAL_EVENTS.ACTION,
    label,
  });
};

const gatorPresentationModalOpen = () => emitModalEvent(MODAL_EVENTS.LABELS.OPEN);

const gatorPresentationModalSlide = ({ slide }: { slide: number }) => emitModalEvent(`Slide ${slide}`);

const gatorPresentationModalCta = () => emitModalEvent(MODAL_EVENTS.LABELS.CTA);

const gatorPresentationModalClose = () => emitModalEvent(MODAL_EVENTS.LABELS.CLOSE);

const gatorShortcut = ({ label }: { label: string }) => {
  const url = new URL(window.location.href);
  const paths = url.pathname.split('/').filter(path => path !== '');
  const userPath = `/${paths[0]}`;
  const userPathData = routesV2(locale).find(route => route.path === userPath);
  const formatedPathName = userPathData.name.replace(/ /g, '-');

  const eventAction = `${EVENTS.ACTIONS.GATOR_SHORTCUT} - ${formatedPathName}`;
  const eventLabel = EVENTS.LABELS[label];

  const event = {
    campaign: EVENTS.CATEGORY,
    action: eventAction,
    label: eventLabel,
  };

  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: eventAction,
    gaEventLabel: eventLabel,
  });
  collectTrackData(event);
};

const gatorHomeSendMessage = ({ messageType }: { messageType: string }) => {
  const eventLabel = HOME_EVENTS.LABELS[messageType];

  collect({
    event: HOME_EVENTS.NAME,
    gaEventCategory: HOME_EVENTS.CATEGORY,
    gaEventAction: HOME_EVENTS.ACTION,
    gaEventLabel: eventLabel,
  });

  collectTrackData({
    campaign: HOME_EVENTS.CATEGORY,
    action: HOME_EVENTS.ACTION,
    label: eventLabel,
  });
};

const analytics = {
  gatorShortcut,
  gatorHomeSendMessage,
  gatorPresentationModalOpen,
  gatorPresentationModalSlide,
  gatorPresentationModalCta,
  gatorPresentationModalClose,
};

export default analytics;
